module.exports = __webpack_public_path__ + "img/iconOfficeGate.aa33bc7a.svg";